import { Col } from 'antd';
import styled from 'styled-components';

export const FeaturesContainer = styled(Col)({
  width: '150rem',
  textAlign: 'center',
});
